<template>
  <v-row>
    <v-col cols="6">
      <v-menu
        v-model="menuFrom"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="formatedDate(selected[0])"
            label="Период от"
            prepend-icon="mdi-calendar"
            readonly
            clearable
            v-bind="attrs"
            v-on="on"
            @click:clear="selected[0] = null"
          />
        </template>
        <v-date-picker
          v-model="selected[0]"
          active-picker="YEAR"
          :max="maxDateString"
          min="2024-03-01"
          locale="Ru-ru"
          type="month"
          @change="menuFrom = false"
        />
      </v-menu>
    </v-col>

    <v-col cols="6">
      <v-menu
        v-model="menuTo"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="formatedDate(selected[1])"
            label="Период до"
            prepend-icon="mdi-calendar"
            readonly
            clearable
            v-bind="attrs"
            v-on="on"
            @click:clear="selected[1] = null"
          />
        </template>
        <v-date-picker
          v-model="selected[1]"
          active-picker="YEAR"
          :max="maxDateString"
          min="2024-04-01"
          locale="Ru-ru"
          type="month"
          @change="menuTo = false"
        />
      </v-menu>
    </v-col>
  </v-row>
</template>


<script>
import moment from 'moment'

export default {
  name: 'DateFromToSelector',
  props: {
    value: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      menuFrom: false,
      menuTo: false,
    }
  },

  computed: {
    selected: {
      get() {
        return this.value
      },
      set(selected) {
        this.$emit('input', selected)
      },
    },

    maxDateString() {
      return moment().subtract(1, 'month').endOf('month').format('Y-M-D')
    },
  },

  methods: {
    formatedDate(date) {
      return date ? moment(date).locale('ru').format('MMMM YYYY') : ''
    },
  },

  mounted() {}
}
</script>


<style scoped lang="scss">

</style>
